import dynamic from 'next/dynamic'

export const SignupIntents = dynamic(() => import('./signup-intents'))
